// extracted by mini-css-extract-plugin
export default {"input-field":"InputField_input-field__k4jxR","header-text":"InputField_header-text__JEvj5"};